import { useNavigate } from "react-router";
import styles from './InfoPage.module.scss';
import stylesSheet from '../Components/Sheet.module.scss';



export const InfoPage = () => {

  let navigate = useNavigate();

  return (
    <>

      <div className={styles.logo}>
        <img width={250} src="assets/img/icons/berso.png" alt="logo"
          onClick={() => {
            navigate(-1);
          }}
        />
      </div>

      <div className={stylesSheet.Sheet + " " + styles.content}>
        <h2>
          Страница комммерческих предложений Галереи BersoАнтик
        </h2>
        <p>
          Настоящая страница предназначена для отображения персональных коммерческих предложений клиентам галереи BersoАнтик.
        </p>
        <p>
          Полный каталог товаров можно найти на <b><a href="https://bersoantik.com/ru/catalog/">основном сайте</a></b>.
        </p>
        <p>
          Детали получения заказа оговариватся с менеджером при оформлении коммерческого предложения.
        </p>

        <h2>
          Реквизиты компании:
        </h2>
        <p>
          ООО «Прогресс-Союз»<br />
          Юридический адрес:<br />
          105082, г. Москва, Спартаковская площадь, д. 14, стр. 3, 1 этаж, комн. 3, оф. 8а<br />
          Фактический адрес:<br />
          105120, г. Москва, Нижняя Сыромятническая, д. 10, стр. 2<br />
          ИНН/КПП 9701029491/770101001<br />
          Расчетный счет: 40702810802630003065<br />
          в АО АЛЬФА-БАНК г. Москва<br />
          Кор. счет 30101810200000000593<br />
          БИК Банка 044525593
        </p>
        <br />
        <p>
          <b>Тел: +7 (915) 286-00-34</b> —
          Магазин на Новой Риге (Юнимолл)
        </p>
        <p>
          <b>Тел: +7 (495) 280-79-81,
            +7 (905) 556-11-19</b> —
          Магазин на ARTPLAY
        </p>
      </div>

    </>
  )
}
